<template>
  <div class="uk-container uk-container-expand">
    <nav class="uk-navbar-container uk-margin" uk-navbar="offset: 0">
      <div class="uk-navbar-left">
        <a class="uk-navbar-item uk-logo uk-padding-remove-left" title="Home" href="/"><img alt="Radioplayer logo" src="~@/assets/images/rp-misc-logo.png" class="uk-width-small"></a>
        <div v-if="apiVersion" class="uk-navbar-item uk-badge uk-text-small uk-margin-small-left">API {{ apiVersion }}</div>
      </div>
      <div class="uk-navbar-right uk-hidden@m">
        <i class="fal fa-bars uk-text-large mp-cursor-pointer" uk-toggle="target: #rp-offcanvas-nav"></i>
      </div>
      <div class="uk-navbar-right uk-visible@m">
        <ul class="uk-navbar-nav">
          <li class="mp-section-discover">
            <a href="/discover/">Discover</a>
          </li>
          <li class="mp-section-docs">
            <a href>Docs</a>
            <div class="uk-navbar-dropdown  uk-width-medium">
              <ul class="uk-nav uk-navbar-dropdown-nav" uk-margin>
                <li>
                  <a class="mp-nav-item" href="/docs/how-to/">
                    <div class="uk-flex-middle uk-grid-small uk-grid" uk-grid>
                      <div class="uk-width-auto"><i class="fal fa-question"></i></div>
                      <div class="uk-width-expand">How-To Guides</div>
                    </div>
                  </a>
                </li>
                <li>
                  <a class="mp-nav-item" href="/api-reference/">
                    <div class="uk-flex-middle uk-grid-small uk-grid" uk-grid>
                      <div class="uk-width-auto"><i class="fal fa-code"></i></div>
                      <div class="uk-width-expand">API Reference</div>
                    </div>
                  </a>
                </li>
                <li>
                  <a class="mp-nav-item" href="/docs/quick-start/">
                    <div class="uk-flex-middle uk-grid-small uk-grid" uk-grid>
                      <div class="uk-width-auto"><i class="fal fa-paper-plane"></i></div>
                      <div class="uk-width-expand">Quick Start</div>
                    </div>
                  </a>
                </li>
                <li>
                  <a class="mp-nav-item" href="/docs/libraries/">
                    <div class="uk-flex-middle uk-grid-small uk-grid" uk-grid>
                      <div class="uk-width-auto"><i class="fal fa-books"></i></div>
                      <div class="uk-width-expand">Libraries</div>
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </li>
          <li class="mp-section-console uk-active">
            <a href="/console/">Console</a>
            <!-- TODO: re-enable once versioned routes are implemented
            <div class="uk-navbar-dropdown uk-width-small">
              <ul class="uk-nav uk-navbar-dropdown-nav" uk-margin>
                <li :class="{ 'uk-active': apiVersion === 'v2' }">
                  <a class="mp-nav-item" href="/console/v2/">
                    <div class="uk-flex-middle uk-grid-small uk-grid" uk-grid>
                      <div class="uk-width-auto"><i class="fal fa-code"></i></div>
                      <div class="uk-width-expand">API v2</div>
                    </div>
                  </a>
                </li>
                <li :class="{ 'uk-active': apiVersion === 'v3' }">
                  <a class="mp-nav-item" href="/console/v3/">
                    <div class="uk-flex-middle uk-grid-small uk-grid" uk-grid>
                      <div class="uk-width-auto"><i class="fal fa-code"></i></div>
                      <div class="uk-width-expand">API v3</div>
                    </div>
                  </a>
                </li>
                <li :class="{ 'uk-active': apiVersion === 'v4' }">
                  <a class="mp-nav-item" href="/console/v4/">
                    <div class="uk-flex-middle uk-grid-small uk-grid" uk-grid>
                      <div class="uk-width-auto"><i class="fal fa-code"></i></div>
                      <div class="uk-width-expand">API v4</div>
                    </div>
                  </a>
                </li>
              </ul>
            </div>
            -->
          </li>
          <li class="mp-section-use-cases">
            <a href="/use-cases/">Use Cases</a>
            <div class="uk-navbar-dropdown uk-width-medium">
              <ul class="uk-nav uk-navbar-dropdown-nav" uk-margin>
                <li>
                  <a class="mp-nav-item" href="/use-cases/hybrid/">
                    <div class="uk-flex-middle uk-grid-small uk-grid" uk-grid>
                      <div class="uk-width-auto"><i class="far fa-car"></i></div>
                      <div class="uk-width-expand">Hybrid Radio in the Car</div>
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </li>
        </ul>
        <div class="uk-navbar-item uk-padding-remove-right">
          <a class="uk-button uk-button-default uk-flex uk-flex-middle" href="https://radioplayer.co.uk/">Back to Radioplayer
            <img alt="" class="mp-inline-arrow" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACcAAAAoCAMAAABKKxPSAAAAJFBMVEVMaXEdHRsdHRsdHRsdHRsdHRsdHRsdHRsdHRsdHRsdHRsdHRssJ0Y7AAAAC3RSTlMA8DCgwEBQ4IAQ6C0ndbcAAAAJcEhZcwAALEoAACxKAXd6dE0AAACXSURBVDiNzdRLDsMgDARQSAn9+P73rZIUisEz9jKzQzyZEQuncEopW8SKSI5ACcLHbWHtP8JhFnlGJh53kadHx6ByBGqH4eQgnB2CiwNwdTY0nAktZ0HTGdB2KwRugcjNELoJYqchcQoyN0LqBsjdHzquQ8816Lof9N0FA67Ddq4F5KPdWYKkOYe1PZRelOXaC793nD2lL8R5EEpSqtw+AAAAAElFTkSuQmCC"/>
          </a>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
  export default {
    name: "Nav",
    computed: {
      apiVersion() {
        return this.$rp && this.$rp.apiVersion ? this.$rp.apiVersion : '';
      }
    }
  };
</script>

<style scoped>
.uk-badge {
  background-color: #3d7d38;
  font-weight: bold;
  padding: 0.3em 0.8em;
}
</style>
